import classNames from 'classnames';
import { ReactNode, useEffect, useMemo, useState } from 'react';

import { setupForDark } from '@theme';

interface Choice {
  label: string | ReactNode;
  value: string;
}

function DropdownReadonly({
  value,
  choices,
  className = '',
  singleChoice = true
}: {
  value: string | string[];
  choices: Choice[];
  className?: string;
  singleChoice?: boolean;
}) {
  const [inputValue, setInputValue] = useState(null);
  const labelsIndex = useMemo(() => {
    const labelsIndex = {};
    choices.forEach((choice) => {
      labelsIndex[choice.value] = choice.label;
    });
    return labelsIndex;
  }, [choices]);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const showSelected = (value: string | string[]): string => {
    // SINGLE CHOICE
    if (singleChoice) {
      return labelsIndex[value as string];

      // MULTIPLE CHOICES
    } else {
      if (value.length === 0) {
        return '';
      }
      return (value as string[]).map((v) => labelsIndex[v]).join(', ');
    }
  };

  return (
    <div className={classNames('py-xs', 'flex flex-row justify-between items-center', className)}>
      <div className={classNames(setupForDark('text-tertiary'), 'P3R')}>
        {showSelected(inputValue)}
      </div>
    </div>
  );
}

export default DropdownReadonly;
